import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { mdiArrowLeft } from '@mdi/js'
import store from '@/store'
import BKCountrySelect from '@/components/AppShared/BKCountrySelect.vue'
import { useImage } from '@/shared/composables/image'
import { UserDB } from '@/enitites/user'

interface IProps {
  loading: boolean
  user: UserDB
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsProfile',
  props: {
    loading: { type: Boolean },
    user: null
  },
  emits: ["update:user", "save"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:user', value: UserDB): void
  (e: 'save'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  loading: boolean
  user: UserDB
};


const { getImageById, saveImage } = useImage()



const isFormValid = ref(false)
const isShowState = ref(false)
const mask = ref('##/##/####')

const dancerNameRules = [(value: string) => !!value || 'Dancer name is required']
const fullNameRules = [(value: string) => !!value || 'Full name is required']
const birthdayRules = (value: string) => {
  const isMoreThanHundredYears = new Date().getFullYear() - new Date(value).getFullYear() > 100
  const isInFutureOrNow = new Date().getFullYear() <= new Date(value).getFullYear()

  if (isMoreThanHundredYears || isInFutureOrNow) return 'Please enter a correct date'

  const pattern = /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d/
  return pattern.test(value) || 'Date format mm/dd/yyyy'
}

const getUser = computed({
  get: () => props.user,
  set: (value) => emit('update:user', value),
})

watch(
  () => getUser.value.country,
  () => {
    getUser.value.city = ''
    getUser.value.state = ''
  }
)

const handlerFileChange = (evt: Event) => {
  const filesImgAvatar = (evt.target as HTMLInputElement).files
  if (!filesImgAvatar || filesImgAvatar.length === 0) return

  const file = filesImgAvatar[0]
  if (file.size > 10000000) {
    store.dispatch('showAlertToast', 'Use an image smaller than 10Mb')
    isFormValid.value = false
    return
  }

  const reader = new FileReader()
  reader.onload = async () => {
    getUser.value.avatar = await saveImage(file)
  }
  reader.readAsDataURL(file)
  isFormValid.value = true
}

return { __sfc: true,props, getImageById, saveImage, emit, isFormValid, isShowState, mask, dancerNameRules, fullNameRules, birthdayRules, getUser, handlerFileChange, mdiArrowLeft, store, BKCountrySelect }
}

})